import Vue from 'vue'
import VueSocketIO from 'vue-socket.io'

Vue.use(new VueSocketIO({
  debug: false,
  connection: `${process.env.VUE_APP_SERVER_URL}`,
}))
